import { render } from "./MsbBasicComponent.vue?vue&type=template&id=105a449c&scoped=true"
import script from "./MsbBasicComponent.vue?vue&type=script&lang=js"
export * from "./MsbBasicComponent.vue?vue&type=script&lang=js"

import "./MsbBasicComponent.vue?vue&type=style&index=0&id=105a449c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105a449c"]])

export default __exports__